import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Icon, IconsComponent } from '../icons/icons.component';

@Component({
  selector: 'vti-round-button',
  standalone: true,
  imports: [CommonModule, IconsComponent],
  templateUrl: './round-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoundButtonComponent {
  public icon = input.required<Icon>();
  public disabled = input<boolean>(false);
  public iconSize = input<number>(5);
  public padding = input<boolean>(false);

  @Output() public onClick: EventEmitter<void> = new EventEmitter<void>();

  public onButtonClick(): void {
    this.onClick.emit();
  }
}
